export default "__VITE_ASSET__8VDTenNp__"